import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'corpId',
      type: 'select',
      label: '主体',
      placeholder: '请选择主体',
      filterable: true,
      clearable: true
    },
    {
      field: 'sid',
      type: 'input',
      label: '账号ID',
      placeholder: '请输入账号ID'
    },
    {
      field: 'usedBy',
      type: 'select',
      label: '使用人',
      filterable: true,
      clearable: true,
      placeholder: '请选择使用人'
    },
    {
      field: 'uname',
      type: 'input',
      label: '客户昵称',
      placeholder: '请输入客户昵称'
    },
    {
      field: 'isRepeat',
      type: 'select',
      label: '是否重复客户',
      clearable: true,
      placeholder: '请选择是否重复客户',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'isRepeatWithinSixMonth',
      type: 'select',
      label: '6个月内重复',
      tooltip: '是否6个月内重复客户',
      clearable: true,
      placeholder: '请选择是否6个月内重复客户',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'isDeletedWithin24Hours',
      type: 'select',
      label: '24小时内删除',
      tooltip: '是否24小时内删除',
      clearable: true,
      placeholder: '请选择是否24小时内删除',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'isDeleted',
      type: 'select',
      label: '是否已删除',
      clearable: true,
      placeholder: '请选择是否已删除',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'isInAfterSales',
      type: 'select',
      label: '是否在售后主体',
      clearable: true,
      placeholder: '请选择是否在售后主体',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'hasCallOnAssignedDay',
      type: 'select',
      label: '当天是否去电',
      tooltip: '新资源承接当天是否去电',
      clearable: true,
      placeholder: '请选择当天是否去电',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'hasConnectedCallOnAssignedDay',
      type: 'select',
      label: '当天是否接通',
      tooltip: '新资源承接当天去电是否有接通',
      clearable: true,
      placeholder: '请选择当天是否接通',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'isNoDevelopPendingTransfer',
      type: 'select',
      label: '不可开发转移',
      tooltip: '是否触发不可开发待转移',
      clearable: true,
      placeholder: '请选择是否触发不可开发待转移',
      options: [
        { title: '是', value: 1 },
        { title: '否', value: 0 }
      ]
    },
    {
      field: 'uid',
      type: 'input',
      label: '客户ID',
      placeholder: '请输入客户ID'
    },
    {
      field: 'unionid',
      type: 'input',
      label: 'UnionId',
      placeholder: '请输入客户unionId'
    },
    {
      field: 'thirdParty',
      type: 'select',
      label: '所属第三方',
      clearable: true,
      filterable: true,
      placeholder: '请选择所属第三方'
    },
    {
      field: 'groupName',
      type: 'select',
      label: '所属组',
      clearable: true,
      filterable: true,
      placeholder: '请选择所属组'
    },
    {
      field: 'sourceLabel',
      type: 'select',
      label: '来源渠道',
      clearable: true,
      filterable: true,
      placeholder: '请选择来源渠道'
    },
    {
      field: 'createdAtRange',
      type: 'datepicker',
      label: '加入时间',
      otherOptions: {
        startPlaceholder: '开始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD'
      }
    }
  ]
}
